module.exports = __webpack_public_path__ + "img/img-introduce-002.ecd28373.png";